import React from 'react';
import { Block } from 'baseui/block';

export const FieldHead = ({ text }: { text: string }) => (
    <Block font="font300" color="mono800">
        {text}
    </Block>
);
